export type SubscriptionTierId = "starter" | "growth" | "professional";

export type SubscriptionTier = {
  id: SubscriptionTierId;
  name: string;
  priceMonthly: number;
  quota: string;
  blurb: string;
  features: string[];
  popular: boolean;
};

// Public pricing for the platform positioning. Checkout wiring is intentionally
// separate until the matching Stripe prices are configured.
export const SUBSCRIPTION_TIERS: readonly SubscriptionTier[] = [
  {
    id: "starter",
    name: "Starter",
    priceMonthly: 79,
    quota: "Up to 15 ASINs",
    blurb: "For focused catalogs that need continuous review coverage.",
    features: [
      "Single brand",
      "Continuous review monitoring",
      "Policy violation detection",
      "Unlimited appeal generation",
      "Managed filing for eligible Brand Registry brands",
      "Email alerts on new flagged reviews",
    ],
    popular: false,
  },
  {
    id: "growth",
    name: "Growth",
    priceMonthly: 199,
    quota: "Up to 60 ASINs",
    blurb: "For growing brands and operators managing multiple product lines.",
    features: [
      "Single brand",
      "Faster review scans",
      "Team members",
      "API access",
      "Everything in Starter",
    ],
    popular: true,
  },
  {
    id: "professional",
    name: "Professional",
    priceMonthly: 499,
    quota: "Up to 200 ASINs",
    blurb: "For larger catalogs where reputation operations need priority handling.",
    features: [
      "Multiple brands",
      "Unlimited appeals",
      "Priority processing",
      "Slack and Teams alerts",
      "Analytics",
      "Priority support",
    ],
    popular: false,
  },
];

export function getTier(id: SubscriptionTierId): SubscriptionTier {
  const t = SUBSCRIPTION_TIERS.find((x) => x.id === id);
  if (!t) throw new Error(`Unknown tier: ${id}`);
  return t;
}
